module.exports = __webpack_public_path__ + "static/media/29ADMSPC20.6be06f29.jpg";